import { ADDER_CATEGORY } from "@logic/lib/powur-os"

import type { EnterpriseSettings } from "~/graphql/client"

const POWURLINE_COMPENSATION_TYPE = `powurline`

/**
 * Determines if a project is a PowurLine project based on enterprise settings
 * @param enterpriseSettings The enterprise settings for the proposal
 * @returns true if this is a PowurLine project
 */
export function isPowurLineProject(
  enterpriseSettings: EnterpriseSettings | null,
): boolean {
  if (!enterpriseSettings) return false

  return enterpriseSettings.compType === POWURLINE_COMPENSATION_TYPE
}

/**
 * Determines if Base Services should be hidden based on enterprise settings
 * @param enterpriseSettings The enterprise settings for the proposal
 * @returns true if Base Services should be hidden
 */
export function shouldHideBaseServices(
  enterpriseSettings: EnterpriseSettings | null,
): boolean {
  return isPowurLineProject(enterpriseSettings)
}

/**
 * Checks if an adder is a Base Service adder
 * @param categoryId The category ID of the adder
 * @returns true if the adder is a Base Service
 */
export function isBaseServiceAdder(
  categoryId: number | null | undefined,
): boolean {
  return categoryId === ADDER_CATEGORY[`Base Services`]
}
